import type { DashboardDataResponseSpec } from "../Processing/types";
import { trainingAPI } from "../../../api/TrainingAPI";

/**
 * Fetch processed query results for every widget on a dashboard.
 * The backend's DashboardEngine executes all QuerySpecs and returns
 * a DashboardDataResponseSpec with results keyed by widget_id.
 *
 * Endpoint: GET /api/dashboard-data/:id → DashboardDataResponseSpec JSON
 */
export async function fetchDashboardData(
  dashboardId: string,
): Promise<DashboardDataResponseSpec> {
  // Each stat tile also carries its stat tiles API answer as `v2`.
  const data = await trainingAPI.getDashboardData(dashboardId, { stat_tiles: "v2" });
  return data as DashboardDataResponseSpec;
}
